const CopyToClipboard = {
  mounted() {
    this.el.addEventListener('click', () => {
      const textToCopy = this.el.dataset.clipboardText

      if (!textToCopy) {
        return
      }

      navigator.clipboard.writeText(textToCopy).then(() => {
        this.el.dataset.copied = 'true'
        setTimeout(() => delete this.el.dataset.copied, 2000)
      })
    })
  },
}

export default CopyToClipboard
